import { render, staticRenderFns } from "./GameManage.vue?vue&type=template&id=84c14be0&scoped=true&"
import script from "./GameManage.vue?vue&type=script&lang=js&"
export * from "./GameManage.vue?vue&type=script&lang=js&"
import style0 from "./GameManage.vue?vue&type=style&index=0&id=84c14be0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c14be0",
  null
  
)

export default component.exports